function reseauLcCleaner(reseauLc) {
  delete reseauLc.selected;
  delete reseauLc.tarifBrutString;
  delete reseauLc.formats;
  delete reseauLc.icon;
  delete reseauLc.jourDepartLibelle;
}

function panneauLcCleaner(panneauLc) {
  delete panneauLc.selected;
  delete panneauLc.dispoClass;
  delete panneauLc.faces;
  delete panneauLc.extensionOpportunite.faceSelectionne.departement;
  delete panneauLc.extensionOpportunite.faceSelectionne.ville;
  delete panneauLc.extensionOpportunite.faceSelectionne.selected;
  delete panneauLc.extensionOpportunite.faceSelectionne.format;
  delete panneauLc.extensionOpportunite.faceSelectionne.materiel;
  delete panneauLc.extensionOpportunite.faceSelectionne.adresse;
  delete panneauLc.extensionOpportunite.faceSelectionne.panNum;
  delete panneauLc.extensionOpportunite.faceSelectionne.panCode;
  delete panneauLc.extensionOpportunite.faceSelectionne.codePostal;
  delete panneauLc.extensionOpportunite.faceSelectionne.dispoClass;
  delete panneauLc.extensionOpportunite.codeFaces;
}

function reseauTempoCleaner(reseauTempo) {
  delete reseauTempo.selected;
  delete reseauTempo.tarifBrutString;
  delete reseauTempo.formats;
  delete reseauTempo.icon;
  delete reseauTempo.jourDepartLibelle;
  delete reseauTempo.dataProposition;
  reseauTempo.listeFaces.forEach((face) => {
    delete face.dispoClass;
  });
}

function panneauNumeriqueCleaner(panneauNumerique) {
  delete panneauNumerique.selected;
  delete panneauNumerique.dispoClass;
  delete panneauNumerique.codeFaces;
  delete panneauNumerique.faces;
}

function reseauxNumeriquesCleaner(reseauNumerique) {
  delete reseauNumerique.selected;
  delete reseauNumerique.tarifBrutString;
  delete reseauNumerique.formats;
  delete reseauNumerique.icon;
  delete reseauNumerique.jourDepartLibelle;
}

export default function produitsCleaner(produits) {
  produits.reseauxLc.forEach((reseauLc) => {
    reseauLcCleaner(reseauLc);
  });
  produits.panneauxLc.forEach((panneauLc) => {
    panneauLcCleaner(panneauLc);
  });

  produits.reseauxTempo.forEach((reseauTempo) => {
    reseauTempoCleaner(reseauTempo);
  });

  produits.panneauxNumeriques.forEach((panneauNumerique) => {
    panneauNumeriqueCleaner(panneauNumerique);
  });

  produits.reseauxNumeriques.forEach((reseauNumeriques) => {
    reseauxNumeriquesCleaner(reseauNumeriques);
  });
}



// WEBPACK FOOTER //
// ./src/services/panier/panierProduitsCleaner.js